// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disabled[data-v-edf7ce8c]{background-color:rgba(55,55,55,.1);border-radius:10px}.preview[data-v-edf7ce8c]{margin:auto;margin-top:auto;display:block;border:2px solid #ccc;padding:2px;margin-top:5px}", ""]);
// Exports
module.exports = exports;
